import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  if (items.length === 0) return null;

  return (
    <nav aria-label="面包屑导航" className="container-custom py-3 md:py-4">
      <ol className="flex items-center flex-wrap gap-1 text-xs md:text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-400 transition-colors duration-300">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <span className="mx-1 text-foreground-600">/</span>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-400 transition-colors duration-300">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-300">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}